import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { makeListRequest } from './makeQueryParams';
import registerSymptomQualifs from './qualifications';
import registerSymptomTypes from './types';
import registerReason from './reason';

const attributesObjRef = {
  nature: {
    serverSide: true,
    values: [],
  },
  work_order_group_qualif_code: {
    serverSide: true,
    values: [],
  },
  work_order_group_type_code: {
    serverSide: true,
    values: [],
  },
  reason_id: {
    serverSide: true,
    values: [],
  },
  customer_name: {
    serverSide: true,
    type: '$instr',
    values: [],
  },
};

const attributesObj = {
  nature: {
    serverSide: true,
    values: [],
  },
  work_order_group_qualif_code: {
    serverSide: true,
    values: [],
  },
  work_order_group_type_code: {
    serverSide: true,
    values: [],
  },
  reason_id: {
    serverSide: true,
    values: [],
  },
  ventilation_affected: {
    serverSide: true,
    values: ['N'],
  },
  customer_name: {
    serverSide: true,
    values: [],
    type: '$instr',
  },
};

export default (store) => {
  store.registerModule(
    ['requests', 'history'],
    new BaseModule({
      attributesObj,
      attributesObjRef,
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
        treatListResponse: treatsItems({
          datetimeFieldNames: ['request_datetime'],
        }),
      }),
      defaultSortBy: ['request_datetime'],
      makeQueryParams: makeListRequest({
        dateField: 'request_datetime',
      }),
      makeHttpParamsUrl: (id) =>
        `${process.env.P2H_BASE_URI}/properties/${id}/workorders_history`,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'requests/history',
    store,
  });

  basePlugin.onActiveRequestChange((request) => {
    store.dispatch(
      `requests/history/setUrlParamIdAndClearFilters`,
      request.property_id
    );
  });
  registerSymptomTypes(store);
  registerSymptomQualifs(store);
  registerReason(store);
};
